import utils from '@eitje/utils'

export const getBorder = ({border, borderLeft, borderRight, borderTop, borderBottom}) => {
	const classNames = []

	if (border) classNames.push('b')
	if (borderLeft) classNames.push('bl')
	if (borderRight) classNames.push('br')
	if (borderTop) classNames.push('bt')
	if (borderBottom) classNames.push('bb')

	return classNames.filter(Boolean)
}
